<template>
  <div>
    <md-dialog :md-active.sync="modalEditaCuenta" :md-click-outside-to-close="false">
        <md-dialog-title class="text-center">
            {{ labels.title }}
        </md-dialog-title>
        <md-dialog-content>
            <b-row class="">
                <b-col cols="3" class="text-left">
                    <h5>{{labels.contable}}</h5>
                </b-col>
                <b-col cols="9" lg="9" class="text-left">
                    <h6>{{ contable === 1 ? 'SI' : 'NO' }}</h6>
                </b-col>
            </b-row>
            <b-row class="" v-if="contable === 1 ? true : showCuenta">
                <b-col cols="3" class="text-left">
                    <h5>{{labels.account}}</h5>
                </b-col>
                <b-col cols="9" lg="9" class="text-left">
                    <h6>{{ cuenta }}</h6>
                </b-col>
            </b-row>
            <b-row class="">
                <b-col cols="3" class="text-left">
                    <h5>{{labels.actual}}</h5>
                </b-col>
                <b-col cols="9" lg="9" class="text-left">
                    <select v-model="actual" id="" class="form-control">
                        <option value="1"> {{ labels.yes }} </option>
                        <option value="0"> {{ labels.not }} </option>
                    </select>
                </b-col>
            </b-row>
            <b-row class="">
                <b-col cols="3" class="text-left">
                    <h5>{{labels.operacion}}</h5>
                </b-col>
                <b-col cols="9" lg="9" class="text-left">
                    <select v-model="operacion" id="" class="form-control">
                        <!-- <option value=""> {{ labels.select }} </option> -->
                        <option value="+"> {{ labels.sumar }} </option>
                        <option value="-"> {{ labels.restar }} </option>
                    </select>
                </b-col>
            </b-row>
            <b-row class="" v-if="showSuma">
                <b-col cols="3" class="text-left">
                    <h5>Suma:</h5>
                </b-col>
                <b-col cols="1" lg="9" class="text-left">
                    <md-field>
                        <md-input v-model="formulacion" type="text"></md-input>
                    </md-field>
                </b-col>
            </b-row>
<div class="tab-content">
<!-- Pestaña NIIF -->
	<div v-if="showNiif" class="niif-selection-container">
		<div class="search-bar">
			<md-field class="search-field">
				<md-input v-model="searchNiif" :placeholder="labels.searchPlaceholder" @input="f_nuevo_criterio_niif()"/>
			</md-field>
			<md-field class="search-field">
				<md-input v-model="searchNivel" :placeholder="labels.searchPlaceholderNivel" @input="f_nuevo_criterio_niif()"/>
			</md-field>
			<div class="selection-info">
				{{ labels.selected }}: {{ selectedNiifs.length }}/{{listNiif.length}}
			</div>
		</div>

		<div class="niif-table-container">
			<table class="niif-table">
			<thead>
			<tr>
				<th class="checkbox-column">
					<md-checkbox :md-checked="selectAll"
					@change="toggleSelectAll" />
				</th>
				<th class="niif-column">NIIF</th>
				<th class="desc-column">Descripción</th>
				<th class="level-column">Nivel 1</th>
				<th class="level-desc-column">Desc. Nivel 1</th>
				<th class="level-column">Nivel 2</th>
				<th class="level-desc-column">Desc. Nivel 2</th>
			</tr>
			</thead>
			<tbody>
			<tr v-for="niif in filteredNiif" :key="niif.id">
				<td class="checkbox-column">
					<md-checkbox v-model="niif._selected"
						@change="onNiifCheckboxChange(niif)"
						class="custom-checkbox">
					</md-checkbox>
				</td>
				<td class="niif-column">{{ niif.niif }}</td>
				<td class="desc-column" :title="niif.nameNiif || niif.descripcion">
					{{ niif.nameNiif || niif.descripcion }}
				</td>
				<td class="level-column">{{ niif.primer_nivel }}</td>
				<td class="level-desc-column"
					:title=" getFirstLevelDescription(niif.namePrimerNivel) ">
					{{ getFirstLevelDescription(niif.namePrimerNivel) }}
				</td>
				<td class="level-column">{{ niif.segundo_nivel }}</td>
				<td class="level-desc-column"
					:title=" getSecondLevelDescription(niif.nameSegundoNivel) ">
					{{ getSecondLevelDescription(niif.nameSegundoNivel) }}
				</td>
			</tr>
			</tbody>
			</table>
			<div v-if="filteredNiif.length === 0" class="no-results">{{ labels.noResults }}
			</div>
		</div>
	</div>
	</div>
            <md-dialog-actions class="mt-3">
                <md-button class="md-primary" @click="guardaCuenta">{{ labels.save }}</md-button>
                <md-button class="md-accent" @click="clicked">{{ labels.close }}</md-button>
            </md-dialog-actions>
        </md-dialog-content>
    </md-dialog>
  </div>
</template>

<script>

import PlanConsolidacion from '../../services/PlanConsolidacion';
import Nivel from '../../services/Nivel'

export default {
    name:"EditaCuenta",
    props:["modalEditaCuenta","dataDetallCuent","vigComSelected"],
    data:() => ({
	cuenta :"",
	contable: "",
	actual: "",
	operacion: "",
	vigencia:"",
	id_compania:"",
	codReporte:"",
	nivel_1:"",
	nivel_2:"",
	nivel_3:"",
	nivel_4:"",
        showCuenta : false,
        showFormulacion : false,
        chk : '',
        showNiif : false,
        showSuma : false,
        sumNiv : "",
        listNiif : [],
        arrNiif : [],
        nivelSelected : {},
        repPrincipal : {},
	searchNiif: "", 
	searchNivel: "",        
	selectedNiifs: [],
	selectAll: false,
	filteredNiif: [],
	info : {},
    }),
    computed: {
        labels(){
            if(this.$store.state._language == "es-ES"){
                return {
                    title : "Edita cuenta",
                    select: "Seleccione...",
                    save : "Guardar",
                    close : "Cerrar",
                    contable : "Contable:",
                    yes : "SI",
                    not : "NO",
                    account : "Cuenta:",
                    actual : "Actual:",
                    operacion : "Operación:",
                    sumar : "+",
                    restar : "-",
                    formulacion : "Formulación:",
                    vigencia : "Vigencia:",
                    company : "Compañía:",
                    searchPlaceholder: "Buscar NIIF...",
                    searchPlaceholderNivel: "Buscar Nivel...",
                }
            }else{
                return {
                    title : "Edit account",
                    select: "Select...",
                    save : "Save",
                    close : "Close",
                    contable : "Accountant:",
                    yes : "YES",
                    not : "NO",
                    account : "Account:",
                    actual : "Actual:",
                    operacion : "Operation:",
                    sumar : "+",
                    restar : "-",
                    formulacion : "Formulation:",
                    vigencia : "Validity:",
                    company : "Company:",
                    searchPlaceholder: "Buscar NIIF...",
                    searchPlaceholderNivel: "Buscar Nivel...",
                }
            }
        }
    },
    methods:{
	f_nuevo_criterio_niif() {
		this.filteredNiif=this.f_filteredNiif()
	},
        f_filteredNiif() {
		const niif = this.searchNiif?.toLowerCase() || "";
		const nivel = this.searchNivel?.toLowerCase() || "";
		
		const listParcial =
			this.listNiif.filter(n =>
				n.niif.toString().includes(niif) ||
				(n.nameNiif && n.nameNiif.toLowerCase().includes(niif)) ||
				(n.descripcion && n.descripcion.toLowerCase().includes(niif)))
		return listParcial.filter(n =>
			n.primer_nivel.toString().includes(nivel) || 
			n.segundo_nivel.toString().includes(nivel) || 
			(n.namePrimerNivel && n.namePrimerNivel.toLowerCase().includes(nivel)) ||
			(n.nameSegundoNivel && n.nameSegundoNivel.toLowerCase().includes(nivel)))
        },
        toggleSelectAll() {
		this.filteredNiif.forEach(n => {
			if	(n._selected === true) {
				n._selected=false
			} else {
				n._selected=true
			}
		});
		this.selectedNiifs = this.listNiif.filter(n => n._selected);
        },
        updateSelectAllState() {
            if (this.filteredNiif.length === 0) {
                this.selectAll = false;
                return;
            }
            this.selectAll = this.filteredNiif.every(n => n._selected);
        },
        guardaCuenta(){
            if	(this.chk == 'n'){
		if	(this.arrNiif.length == 0) {
			this.$toast.success("Niif sin seleccionar")
			return
		}
            }
            this.info.chkSel = this.chk
            this.info.actual = this.actual
            this.info.operacion = this.operacion
            this.info.idUser = this.$store.state.userId
            if(this.chk == 'm'){
                this.info.formulacion = "MANUAL"
            }else if(this.chk == 'n'){
		this.arrNiif=this.filteredNiif.filter(niif => niif._selected === true)
                this.info.formulacion = this.arrNiif
            
            }else if(this.chk == 's'){
                this.info.formulacion=this.formulacion
            }

            if(this.$route.params.tipo == 'directo'){
                
                Nivel.updateCuentaNivelEfe(this.info)
                .then((res) => {
                    this.$toast.success(res.data.message)
                    this.clicked()
                })
                .catch((err) => {
                    console.log(err)
                })
                .finally(() => {
                    setTimeout(() => {                        
                        this.reloadTable()
                    }, 2000);
                })
            }else{
                
                Nivel.updateCuentaNivelEfeInd(this.info)
                .then((res) => {
                    this.$toast.success(res.data.message)
                    this.clicked()
                })
                .catch((err) => {
                    console.log(err)
                })
                .finally(() => {
                    setTimeout(() => {                        
                        this.reloadTable()
                    }, 2000);
                })
            }
        },
        clicked(){
            this.$emit('clicked', false);
        },
        reloadTable(){
            this.nivelSelected = {
                'nivelUno'      : this.dataDetallCuent[0].nivel_1,
                'nivelDos'      : this.dataDetallCuent[0].nivel_2,
                'nivelTres'     : this.dataDetallCuent[0].nivel_3,
                'nivelCuatro'   : this.dataDetallCuent[0].nivel_4
            }
            this.$emit('reloadTable',this.nivelSelected,this.dataDetallCuent[0].vigencia,this.dataDetallCuent[0].id_compania,this.vigComSelected.codReporte)
        },
        clearFields() {
            this.niif = "";
            this.descripcion = "";
            this.primerNivel = "";
            this.segundoNivel = "";
            this.actual = "";
            this.operacion = "";
            this.niifSelect = [];
            this.listNiif = [];
            this.selectedNiifs = [];
            this.hasUnsavedChanges = false;
            this.selectAll = false;
            this.searchNiif = "";
            this.searchNivel = "";
        },
        getFirstLevelDescription(levelDescripcion) {
            return levelDescripcion ? levelDescripcion : '-';
        },
        getSecondLevelDescription(levelDescripcion) {
            return levelDescripcion ? levelDescripcion : '-';
        },
        onNiifCheckboxChange(niif) {
            if (niif._selected) {
                if (!this.selectedNiifs.some(n => n.niif === niif.niif)) this.selectedNiifs.push(niif);
            } else {
                this.selectedNiifs = this.selectedNiifs.filter(n => n.niif !== niif.niif);
            }
            this.updateSelectAllState();
        },
},
	
mounted(){
	this.clearFields();
	PlanConsolidacion.getPlanConsPorCompVige(this.vigComSelected.vigencia, this.vigComSelected.codReporte)
	.then((res) => {
		this.listNiif = res.data.planConsNiif || [];
		this.listNiif.forEach(n => n._selected = false);
		this.selectedNiifs = [];
		this.filteredNiif=this.f_filteredNiif()
	})
	.catch((err) => console.log(err))
},

watch:{
        dataDetallCuent(valNuevo){
		const valNew=valNuevo[0]
		this.info = valNew
		this.chk = ''
		this.contable=valNew.contable
		this.cuenta=valNew.cuenta
		this.actual=valNew.operacion == "+" ? "1" : "0"
		this.operacion=valNew.operacion
		this.formulacion=valNew.formulacion
		this.vigencia=valNew.vigencia
		this.id_compania=valNew.id_compania
		this.codReporte=valNew.codReporte
		if	(valNew.formulacion.slice(0,1) == "M") {
			this.chk = 'm'
			this.showNiif = false
			this.showSuma = false

		}
		if	(valNew.formulacion.slice(0,1) == ""){
			this.showNiif = false
			this.showSuma = false
		}
		if	(valNew.formulacion.slice(0,1) == "N") {
			this.chk = 'n'
			this.showNiif = true
			this.showSuma = false
			this.arrNiif=valNew.formulacion.split(',')
			this.arrNiif[0]=this.arrNiif[0].replace('Niif(','')
			this.arrNiif[this.arrNiif.length-1]=this.arrNiif[this.arrNiif.length-1].replace(')','')
			this.filteredNiif.forEach((v_niif,idx) => {
				const vl_niif = v_niif.niif.toString()
				if (this.arrNiif.includes(vl_niif)) {
					this.filteredNiif[idx]._selected=true
				} else {
					this.filteredNiif[idx]._selected=false
				}
			})
		}
		if	(valNew.formulacion.slice(0,1) == "S") {
			this.chk = 's'
			this.showSuma = true
			this.showNiif = false
		}
	},
        chk(valNew){
            if(valNew == "m"){
                // this.dataDetallCuent.formulacion = ""
                this.showNiif = false
                this.showSuma = false
                this.dataDetallCuent.chkSel = valNew

            }else if(valNew == "n"){
                this.dataDetallCuent.formulacion = ""
                this.showNiif = true
                this.showSuma = false
                this.dataDetallCuent.chkSel = valNew
            }else if(valNew == "s"){
                // this.dataDetallCuent.formulacion = ""
                this.showSuma = true
                this.showNiif = false
                this.dataDetallCuent.chkSel = valNew
            }
        }
    }
}
</script>

<style scoped>
/* Estilos base */
.dialog-header {
    background: #34495e;
    color: white;
    padding: 20px 24px;
    border-bottom: 1px solid #2c3e50;
}
.header-title { font-size: 1.3rem; font-weight: 500; }
.dialog-content { padding: 20px 24px; max-height: 80vh; overflow-y: auto; }
.form-container { display: flex; flex-direction: column; gap: 20px; }
.form-group { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; }
.form-field-full { width: 100%; }

/* Labels y campos */
.field-label { 
    display: block; font-weight: 600; color: #2c3e50; margin-bottom: 8px; 
    font-size: 14px; text-transform: uppercase; letter-spacing: 0.5px; 
}
.custom-field { margin: 0; }
.modern-select { 
    width: 100%; padding: 12px 16px; border: 1px solid #bdc3c7; border-radius: 4px; 
    background: white; font-size: 14px; color: #2c3e50; outline: none; 
    transition: border-color 0.2s ease; 
}
.modern-select:focus { border-color: #3498db; box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.1); }

/* Pestañas */
.tabs-container { border: 1px solid #e9ecef; border-radius: 4px; overflow: hidden; }
.tabs-header { display: flex; background: #f8f9fa; border-bottom: 1px solid #e9ecef; }
.tab-button { 
    flex: 1; padding: 12px 16px; background: none; border: none; 
    border-bottom: 3px solid transparent; font-weight: 600; color: #6c757d; 
    cursor: pointer; transition: all 0.3s ease; font-size: 14px; 
    text-transform: uppercase; letter-spacing: 0.5px; 
}
.tab-button:hover { background: #e9ecef; color: #495057; }
.tab-button.active { color: #3498db; border-bottom-color: #3498db; background: white; }
.tab-content { background: white; }

/* Barras de búsqueda comunes */
.search-bar { 
    display: flex; justify-content: space-between; align-items: center; 
    padding: 12px 16px; background: #f8f9fa; border-bottom: 1px solid #e9ecef; 
}
.search-field { margin: 0; flex: 1; max-width: 300px; }
.selection-info { color: #6c757d; font-size: 14px; font-weight: 500; }

/* Tablas comunes */
.niif-table-container, .redefiniciones-table-container { 
    max-height: 400px; overflow-y: auto; 
}
.niif-table, .redefiniciones-table { 
    width: 100%; border-collapse: collapse; background: white; font-size: 13px; 
}
.niif-table thead, .redefiniciones-table thead { 
    position: sticky; top: 0; z-index: 100; 
}
.niif-table th, .redefiniciones-table th { 
    background: #34495e; color: white; padding: 8px 4px; text-align: left; 
    font-weight: 600; font-size: 12px; text-transform: uppercase; 
    white-space: nowrap; border-bottom: 2px solid #2c3e50; 
}
.niif-table td, .redefiniciones-table td { 
    padding: 4px 4px; border-bottom: 1px solid #e9ecef; 
    line-height: 1.2; vertical-align: middle; 
}
.niif-table tr, .redefiniciones-table tr { height: 28px; }
.niif-table tr:hover, .redefiniciones-table tr:hover { background: #f8f9fa; }


/* Columnas ordenables */
.sortable { 
    cursor: pointer; transition: background-color 0.2s ease; 
    user-select: none; position: relative; 
}
.sortable:hover { background: #2c3e50; }
.sort-indicator { margin-left: 4px; font-weight: bold; font-size: 12px; }

/* Columnas específicas */
.checkbox-column, .action-column { width: 50px; text-align: center; padding: 0 2px; }
.niif-column { width: 70px; font-weight: 600; color: #2c3e50; text-align: center; }
.desc-column { 
    width: 180px; min-width: 180px; max-width: 180px; 
    white-space: nowrap; overflow: hidden; text-overflow: ellipsis; 
}
.level-column { width: 60px; text-align: center; font-weight: 600; }
.level-desc-column { 
    width: 140px; min-width: 140px; max-width: 140px; 
    white-space: nowrap; overflow: hidden; text-overflow: ellipsis; font-size: 12px; 
}
.formulation-column { 
    width: 200px; min-width: 200px; max-width: 200px; 
    white-space: nowrap; overflow: hidden; text-overflow: ellipsis; 
    font-size: 11px; color: #6c757d; 
}

/* Componentes específicos */
.custom-checkbox { margin: 0; }
:deep(.custom-checkbox.md-checked .md-checkbox-container) { 
    background: #e74c3c !important; border-color: #e74c3c !important; 
}
:deep(.custom-checkbox.md-checked .md-checkbox-container::after) { 
    border-color: white !important; 
}
.select-btn { margin: 0; padding: 0; min-width: 30px; height: 30px; }
:deep(.select-btn .md-ripple) { padding: 4px; }
:deep(.select-btn .b-icon) { font-size: 16px; color: #3498db; }
.clickable-row { cursor: pointer; transition: background-color 0.2s ease; }
.clickable-row:hover { background: #e3f2fd !important; }

/* Estados y mensajes */
.no-results { 
    padding: 20px; text-align: center; color: #6c757d; 
    font-style: italic; font-size: 14px; 
}

/* Acciones del diálogo */
.dialog-actions { 
    padding: 16px 24px; border-top: 1px solid #ecf0f1; 
    display: flex; justify-content: space-between; align-items: center; 
    gap: 12px; background: #f8f9fa; 
}
.actions-left, .actions-right { display: flex; }
.actions-right { gap: 12px; }

/* Botones */
.delete-btn { background: #e74c3c !important; color: white !important; }
.cancel-btn { background: #95a5a6 !important; color: white !important; }
.save-btn { background: #3498db !important; color: white !important; }
.delete-btn, .cancel-btn, .save-btn { 
    font-size: 14px; padding: 8px 16px; min-width: 90px; 
}
.delete-btn:hover { background: #c0392b !important; }
.cancel-btn:hover { background: #7f8c8d !important; }
.save-btn:hover { background: #2980b9 !important; }

/* Scroll personalizado */
.niif-table-container::-webkit-scrollbar,
.redefiniciones-table-container::-webkit-scrollbar { width: 6px; }
.niif-table-container::-webkit-scrollbar-track,
.redefiniciones-table-container::-webkit-scrollbar-track { background: #f1f1f1; }
.niif-table-container::-webkit-scrollbar-thumb,
.redefiniciones-table-container::-webkit-scrollbar-thumb { 
    background: #c1c1c1; border-radius: 3px; 
}
.niif-table-container::-webkit-scrollbar-thumb:hover,
.redefiniciones-table-container::-webkit-scrollbar-thumb:hover { background: #a8a8a8; }

/* Tooltips */
.desc-column:hover::after, .level-desc-column:hover::after, 
.formulation-column:hover::after { 
    content: attr(title); position: absolute; background: #333; color: white; 
    padding: 4px 8px; border-radius: 4px; font-size: 12px; z-index: 1000; 
    white-space: normal; max-width: 300px; 
}

/* Responsive */
@media (max-width: 768px) {
    .form-group { grid-template-columns: 1fr; gap: 16px; }
    .form-container { padding: 16px; }
    .dialog-actions { 
        padding: 12px 16px; flex-direction: column; gap: 10px; 
    }
    .actions-left, .actions-right { width: 100%; justify-content: center; }
    .delete-btn, .cancel-btn, .save-btn { 
        width: 100%; font-size: 13px; padding: 10px; 
    }
    .search-bar { flex-direction: column; gap: 10px; align-items: stretch; }
    .search-field { max-width: 100%; }
    .niif-table-container, .redefiniciones-table-container { max-height: 300px; }
    .tabs-header { flex-direction: column; }
    .tab-button { 
        text-align: center; border-bottom: 1px solid #e9ecef; border-right: none; 
    }
    .tab-button.active { 
        border-bottom: 3px solid #3498db; border-right: none; 
    }
    .desc-column, .level-desc-column, .formulation-column { 
        max-width: 120px; min-width: 120px; 
    }
}
</style>

